
import { config } from '@/conf'
import LangSelectModal from '@/components/ui/lang-select-modal.vue'
import { modal } from '@/components/main/modal'
import { languages } from '@/utils/language'

export default {
  setup () {

    // display language select modal
    const prompt_lang_select = () => {
      modal.show(LangSelectModal)
    }

    return {
      config,
      languages,
      prompt_lang_select
    }
  }
}
